import { Component, Input, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { filter, map, mergeMap } from "rxjs/operators";
import { CommonService } from "src/app/views/common/services/common.service";

@Component({
  selector: "app-breadcrumb",
  templateUrl: "./breadcrumb.component.html",
})
export class BreadcrumbComponent implements OnInit {
  @Input() layout;
  pageInfo;
  shortDesc;
  shortDescMap = {
    'all': 'All',
    'desc': 'Newest First',
    'asc': 'Oldest First',
    'download_customer_comment': 'Download - Pending Customer Comment',
    'usb_customer_comment': 'USB - Pending Customer Comment',
    'postageAsc': 'Newest Pending Postal Orders',
    'postageDesc': 'Oldest Pending Postal Orders',
    'deadline': 'Order Site Deadline',
  };
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private commonServ: CommonService
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .pipe(filter((route) => route.outlet === "primary"))
      .pipe(mergeMap((route) => route.data))
      .subscribe((event) => {
        this.titleService.setTitle(event["title"]);
        this.pageInfo = event;
        this.shortDesc = '';
        if(event.title == 'Orders' || event.title == 'Site Orders') {
          this.pageInfo.title = 'Orders';
          this.activatedRoute.queryParams.subscribe((params) => {
            let queryParams = params;
            if (queryParams.criteria != undefined) {
              if (queryParams.criteria == 'pendingSiteData') {
                this.shortDesc = 'Pending / ' + queryParams.name;
                this.pageInfo.title = 'Site Orders';
              } else {
                this.shortDesc = this.shortDescMap[queryParams.criteria];
              }
            }
          })
        }
      });
    this.commonServ.setDynamicBreadCrumb.subscribe((res: any) => {
      this.pageInfo = {
        title: res,
      };
    });
  }
  ngOnInit() { }
}
